export default __webpack_public_path__ + "static/media/happy.c6f3f672.svg";